import '../assets/ComboboxChevron.css';var g = Object.defineProperty, z = Object.defineProperties;
var R = Object.getOwnPropertyDescriptors;
var c = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, v = Object.prototype.propertyIsEnumerable;
var l = (o, e, r) => e in o ? g(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, n = (o, e) => {
  for (var r in e || (e = {}))
    m.call(e, r) && l(o, r, e[r]);
  if (c)
    for (var r of c(e))
      v.call(e, r) && l(o, r, e[r]);
  return o;
}, a = (o, e) => z(o, R(e));
var h = (o, e) => {
  var r = {};
  for (var s in o)
    m.call(o, s) && e.indexOf(s) < 0 && (r[s] = o[s]);
  if (o != null && c)
    for (var s of c(o))
      e.indexOf(s) < 0 && v.call(o, s) && (r[s] = o[s]);
  return r;
};
import { jsx as i } from "react/jsx-runtime";
import { f as S, u as B, B as L } from "../factory-ueRxoNOV.js";
import { u as N } from "../use-styles-DToiHEa6.js";
import { c as P } from "../create-vars-resolver-Bzbn9G-G.js";
import { c as j } from "../get-size-Bc1Pz5yf.js";
const M = "ComboboxChevron-module__chevron___w-2dT", T = {
  chevron: M
}, V = {
  error: null
}, k = P((o, { size: e }) => ({
  chevron: {
    "--combobox-chevron-size": j(e, "combobox-chevron-size")
  }
})), H = S((o, e) => {
  const r = B("ComboboxChevron", V, o), t = r, { size: s, error: b, style: p, className: d, classNames: u, styles: x, unstyled: f, vars: C, mod: w } = t, y = h(t, ["size", "error", "style", "className", "classNames", "styles", "unstyled", "vars", "mod"]), _ = N({
    name: "ComboboxChevron",
    classes: T,
    props: r,
    style: p,
    className: d,
    classNames: u,
    styles: x,
    unstyled: f,
    vars: C,
    varsResolver: k,
    rootSelector: "chevron"
  });
  return /* @__PURE__ */ i(
    L,
    a(n(n({
      component: "svg"
    }, y), _("chevron")), {
      size: s,
      viewBox: "0 0 448 512",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      mod: ["combobox-chevron", { error: b }, w],
      ref: e,
      children: /* @__PURE__ */ i(
        "path",
        {
          d: "M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    })
  );
});
export {
  H as ComboboxChevron
};
